export default {
    navTopMenuOverlay: '-1',
    bottomPanelIndex: '2',
    landingDropdown: '3',
    navTopMenu: '4',
    leftMenuIndex: '5',
    navBar: '5',
    modalIndex: '6',
    chatIndex: '7',
    spinnerOverlay: '100',
    promoBanner: '10',
    storiesNote: '100',
    storiesProgress: '101',
};
